import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationInterface } from '../../models/notification.model';
import { COURSE_DATE_FORMAT, TWELVE_HOURS_FORMAT } from '../../constants/app.constant';
import { NotificationService } from '../../services/api/notification.service';
import { ErrorService } from '../../services/error.service';
import { getNotificationModuleTypeRoutingOption } from '../../constants/ui-utils.constant';
import { Router } from '@angular/router';
import { ModuleType } from '../../enum/ui-utils.enum';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss',
})
export class NotificationComponent implements OnInit {
    @Output() closeNotificationDropdown = new EventEmitter<boolean>();
    @Input() isNotificationOpen: boolean = false;

    protected isLoading = false;
    protected isAllNotificationRead = true;

    protected notificationData: NotificationInterface[] = [];

    protected COURSE_DATE_FORMAT = COURSE_DATE_FORMAT;
    protected TWELVE_HOURS_FORMAT = TWELVE_HOURS_FORMAT;

    protected getNotificationModuleTypeRoutingOption = getNotificationModuleTypeRoutingOption;

    constructor(
        private notificationService: NotificationService,
        private errorService: ErrorService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.getNotificationListing();
    }

    protected onNotificationClick(data: NotificationInterface): void {
        let fullPath = '';
        let paramQuery = null;
        let notificationId = null;

        if (
            data.moduleItemType === ModuleType.Course ||
            data.moduleItemType === ModuleType.Webinar ||
            data.moduleItemType === ModuleType.Podcast ||
            data.moduleItemType === ModuleType.Aae ||
            data.moduleItemType === ModuleType.Article
        ) {
            fullPath = `${this.getNotificationModuleTypeRoutingOption(data.moduleItemType).label}/${data.moduleItemId}`;
        } else {
            if (this.getNotificationModuleTypeRoutingOption(data.moduleItemType).label) {
                fullPath = `${this.getNotificationModuleTypeRoutingOption(data.moduleItemType).label}`;

                if (data.moduleItemType === ModuleType.Announcement || data.moduleItemType === ModuleType.Others) {
                    notificationId = data.notificationRecipientId;
                } else {
                    paramQuery = data.moduleItemTitle;
                }
            }
        }

        if (!data.isRead) {
            this.markNotificationAsRead(data.notificationRecipientId);
        }

        if (fullPath) {
            let tempQueryParams = {
                search: paramQuery,
                notificationId,
            }

            if(data.moduleItemType == ModuleType.QuickGuide){
                tempQueryParams = {...tempQueryParams, ...{isShow: true}};
            }

            this.router.navigate([fullPath], {
                queryParams: tempQueryParams
            });

            this.closeNotificationDropdown.emit();
        }
    }

    protected onSeeAllNotificationClick(): void {
        this.closeNotificationDropdown.emit(true);
    }

    protected markAllAsRead(): void {
        this.notificationService.markAllNotificationAsRead().subscribe({
            next: async () => {
                this.isAllNotificationRead = true;

                await this.notificationData.forEach((notification) => {
                    notification.isRead = true;
                });

                this.notificationService.notificationRefreshOnRead.next(true);
            },
            error: (err) => {
                this.errorService.showError(err);
            },
        });
    }

    private markNotificationAsRead(id: number): void {
        this.notificationService.markNotificationAsRead(id).subscribe({
            next: async () => {
                this.notificationService.notificationRefreshOnRead.next(true);

                await this.notificationData.forEach((notification) => {
                    if (notification.notificationRecipientId === id) {
                        notification.isRead = true;
                    }
                });

                this.initReadAllNotificationStatus();
            },
            error: (err) => {
                this.errorService.showError(err);
            },
        });
    }

    private initReadAllNotificationStatus(): void {
        this.notificationData.forEach((notification) => {
            if (!notification.isRead) {
                this.isAllNotificationRead = false;

                return;
            }
        });
    }

    private getNotificationListing(): void {
        this.notificationService.isLoading$.subscribe((loading) => {
            this.isLoading = loading;
        });

        this.notificationService.notificationData$.subscribe((data) => {
            this.notificationData = data;

            this.initReadAllNotificationStatus();
        });

        this.notificationService.refreshNotifications();
    }
}
